import {
  FaRegHeart,
  FaShoppingCart,
  FaBoxOpen,
} from "react-icons/fa";

import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

import { useCart } from "../../context/CartContext";
import api from "../../api";

export default function IconButtons() {
  const navigate = useNavigate();

  // GLOBAL STATE (REAL TIME)
  const { cartCount, setCartCount } = useCart();

  const user = JSON.parse(
    localStorage.getItem("user") || "{}"
  );

  const token = user?.access;

  const fetchCartCount = async () => {
    if (!token) return;

    try {
      const res = await api.get("/api/carts/", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = res.data;

      const userId = user?.pk || user?.id;

      const userCart = data.find(
        (c) =>
          Number(c.user) === Number(userId) &&
          c.is_active === true
      );

      const count =
        userCart?.items?.reduce(
          (sum, item) => sum + item.quantity,
          0
        ) || 0;

      setCartCount(count);
    } catch (err) {
      console.log(err);
    }
  };

  // LOAD ON MOUNT
  useEffect(() => {
    fetchCartCount();
  }, []);

  const handleHeartClick = () => {
    navigate("/favourite");
  };

  const handleCart = () => {
    navigate("/cart");
  };

  const handleOrders = () => {
    navigate("/orders");
  };

  return (
    <div className="flex items-center gap-4 text-[#3b2a1f]">
      {/* Favorites */}
      <button
        aria-label="Favorites"
        onClick={handleHeartClick}
        className="
          relative
          text-[#3b2a1f]
          hover:text-[#7A1F1F]
          transition
          duration-200
        "
      >
        <FaRegHeart />
      </button>

      {/* Orders */}
      <button
        aria-label="Orders"
        onClick={handleOrders}
        className="
          relative
          text-[#3b2a1f]
          hover:text-[#7A1F1F]
          transition
          duration-200
        "
      >
        <FaBoxOpen />
      </button>

      {/* Cart */}
      <button
        aria-label="Shopping Bag"
        onClick={handleCart}
        className="
          relative
          text-[#3b2a1f]
          hover:text-[#7A1F1F]
          transition
          duration-200
        "
      >
        <FaShoppingCart />

        {/* Badge */}
        {cartCount > 0 && (
          <span
            className="
              absolute
              -top-2
              -right-2
              bg-[#7A1F1F]
              text-white
              text-[10px]
              font-semibold
              w-4
              h-4
              flex
              items-center
              justify-center
              rounded-full
            "
          >
            {cartCount}
          </span>
        )}
      </button>
    </div>
  );
}